module.exports = __webpack_public_path__ + "static/media/pgd-dark.c8e6722b.png";